export default __webpack_public_path__ + "static/fall29-30eb9ca2be55dcc0f4a3ca829e3b4585.webp";